
//Setting a data to the global state variable
export const GET_TERMS = (state, response) => {

    let _ = require('lodash');
    let expectedSortedOrder = _.orderBy(response.data, ['name'], ['asc']);
    state.terms = expectedSortedOrder;
}

export const GET_PREVIOUSTERMS = (state, response) => {
    let _ = require('lodash');
    let expectedSortedOrder = _.orderBy(response.data, ['name'], ['asc']);
    state.previousTerms = expectedSortedOrder;
}

export const SHOW_SNACKBAR = (state, snackConfig) => {
    state.snackBarMessage = snackConfig.message;
    state.snackBarStatus = snackConfig.status;
    state.isSnackbarEnabled = true;

    setTimeout(function () {
        state.isSnackbarEnabled = false;
        state.snackBarMessage = '';
    }, 3000);
}


export const GET_DEPTS = (state, responseObj) => {
    // responseObj.orderBy(responseObj.res.data)
    let _ = require('lodash');
    let expectedSortedOrder = _.orderBy(responseObj.res.data, ['name'], ['asc']);
    state.student.courseFinder[responseObj.index].departments = expectedSortedOrder
}

export const GET_COURSES = (state, responseObj) => {
    let _ = require('lodash');
    let expectedSortedOrder = _.orderBy(responseObj.res.data, ['sisCourseId'], ['asc']);
    state.student.courseFinder[responseObj.index].courses = expectedSortedOrder;
}

export const USER_LOGIN = (state) => {
    state.username = localStorage.getItem("username")
    state.token = localStorage.getItem("access_token")
    state.userSid = localStorage.getItem("SID");
    state.sisUserId = localStorage.getItem("sisUserId");
    if (state.username && state.token && state.userSid) {
        state.isLoggedIn = true
    }
}

export const USER_LOGOUT = (state) => {
    state.username = null
    state.token = null
    state.userSid = null
    state.isLoggedIn = false
}

export const VOID = () => {
}

export const DISPLAY_LOADER = (state, show) => {
    state.isLoading = show;
}

export const ADD_COURSE_MATERIAL = (state, courseMaterial) => {
    state.student.courseFinder.push(courseMaterial)
}

export const ADD_NEW_AUTHOR = (state, author) => {
    state.newAuthors.push(author)
}

export const GET_SEARCHRESULTS = (state, responseObj) => {
    state.searchResults = responseObj.data
}

export const GET_ADOPTIONSBYINSTRUCTOR = (state, res) => {
    state.adoptionsbyinstructor = res.data
}
export const UPDATE_SECTIONS = (state, courseDetails) => {
    let courseId = courseDetails.id;
    let index = courseDetails.index;
    let sections = state.student.courseFinder[index].courses.filter(x => x.courseId == courseId)[0].sections;
    let _ = require('lodash');
    state.student.courseFinder[index].sections = _.orderBy(sections, ['sectionNumber'], ['asc']);
}

export const SAVE_SECTIONS_SELECTION = (state, sections) => {
    state.selectedSections = sections;
}

export const GET_ADOPTIONS = (state, res) => {
    state.adoptions = res.data;
}

export const GET_ADOPTIONSBYSECTIONS = (state, res) => {
    state.adoptionsbysection = res.data;
}